import Glide from '@glidejs/glide'
import { SCROLLING_SPEED } from 'constants'
class ActiveItems {
    constructor(activeItems) {
        this.activeItems = activeItems

        this.ActiveItems = new Glide(this.activeItems, {
            animationDuration: SCROLLING_SPEED,
            focusAt: 'center',
            perView: 3,
            peek: 0, // How much px is visible from the sides of carousel - to see part of other slides
            type: 'slider',
            gap: 0,
            direction: 'rtl',
            keyboard: false,
        })

        this.ActiveItems.mount({ CustomEvents: ActiveItems.CustomEvents })
    }

    static CustomEvents(_Glide, Components, Events) {
        const { Build } = Components

        Events.on('move', () => {
            // Toggle active class instantly on carousel move
            if (Build) {
                Build.activeClass()
            }
        })

        return {}
    }
}

export default ActiveItems
